module.exports = __webpack_public_path__ + "static/img/story2.ab861d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/story2.png
// module id = rL7S
// module chunks = 0